export const WheelChairIcon = () => <span className={'icon-sata-wheel-chair'}/>;
